/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyForint = createReactComponent("currency-forint", "IconCurrencyForint", [
  ["path", { d: "M11 4h-4a3 3 0 0 0 -3 3v12", key: "svg-0" }],
  ["path", { d: "M10 11h-6", key: "svg-1" }],
  ["path", { d: "M16 4v13a2 2 0 0 0 2 2h2", key: "svg-2" }],
  ["path", { d: "M19 9h-5", key: "svg-3" }]
]);

export { IconCurrencyForint as default };
//# sourceMappingURL=IconCurrencyForint.js.map
